// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__ERHyB","title":"Images45_title__bTFyA","images":"Images45_images__3bfQ8"};